import styled from 'styled-components';

export const HelpText = styled.div`
  ${({ theme: { font } }) => font.t4};
`;

export const SocialButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-bottom: 24px;
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const LoginFooterWrapper = styled.div`
  color: ${({ theme: { font } }) => font.t3};
  font-size: 0.75rem;

  a {
    color: ${({ theme: { color } }) => color.s1};
    text-decoration: none;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 18px;
  margin-bottom: 4px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
